export default __webpack_public_path__ + "static/media/bulb-off.91e3f1c4.svg";